/*
 *
 *  Category
 *  contains basic js for the category page
 *  !! Created by Charlotte on 10/07/2017
 *
 */

import '../cart.js';

window.appLoaded.then(() => {
    $(document).ready(function () {
        // Initialize
        InitPager();
        InitSortorder();
        InitFilters();
        InitAddToCart();
        toggleFilters();

        $('main').on('click', 'a.trigger', function () {
            $(this).next().toggleClass('d-block hidden');
            return false;
        });
        // history.replaceState({path: window.location.href}, '');
        // history.pushState({path: window.location.href}, '', window.location.href);
    });

    function toggleFilters() {
        $('body').on('click', '.toggle-filters', function () {
            $('body').toggleClass('filters-open');
            return false;
        });
    }

    // Click on back/forward button from browser
    window.addEventListener('popstate', function (e) {
        // The URL is correct when clicking on the back button, but not the content, so this has to be reloaded by ajax
        // Load articles
        LoadArticles();

        // Scroll to top catalog overview
        $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
        return false;
    });

    function InitPager() {
        $('.pagination a').click(function () {
            // Change url page
            var strNewUrl = $(this).attr('href');
            window.history.pushState({path: strNewUrl}, '', strNewUrl);

            // Load articles
            LoadArticles();

            // Scroll to top catalog overview
            $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
            return false;
        });
    }

    function InitSortorder() {
        // Update sortorder
        $('button[data-type="sortorder"]').click(function () {
                // Save sortorder in session
                $.post(strAjaxPath + 'catalog-sort.php', 'value=' + $(this).attr('data-value'), function (objResponse) {
                    // Load articles
                    LoadArticles();
                }, 'json');
                return false;
            },
        );
    }


    function InitFilters() {
        $('div.filters a').click(function () {
            // Change url page
            var strNewUrl = $(this).attr('href');
            window.history.pushState({path: strNewUrl}, '', strNewUrl);

            // Load articles
            LoadArticles();

            // Scroll to top catalog overview
            $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
            return false;
        });

        // Toggle availability filter
        $('.toggle-availability-filter').on('click', function (e) {
            e.preventDefault();
            $('[data-availability-filter="open"]').toggleClass('hidden');
            $('[data-availability-filter="closed"]').toggleClass('hidden');
        });

        // Disable start_time if no date is selected
        $('#date').on('change', function () {
            if ($(this).val() === '') {
                $('#start_time').prop('disabled', true).val('');
                $('label[for="start_time"]').addClass('text-gray-400');
                $('#end_time').prop('disabled', true).val('');
                $('label[for="end_time"]').addClass('text-gray-400');
            } else {
                $('#start_time').prop('disabled', false);
                $('label[for="start_time"]').removeClass('text-gray-400');
            }
        });

        // Disable end_time if no start_time is selected
        $('#start_time').on('change', function () {
            if ($(this).val() === '') {
                $('#end_time').prop('disabled', true).val('');
                $('label[for="end_time"]').addClass('text-gray-400');
            } else {
                $('#end_time').prop('disabled', false);
                $('label[for="end_time"]').removeClass('text-gray-400');
            }
        });

        // Remove empty filter values from url
        $('#availability-filter').on('submit', function () {
            $(this).find('input, select').each(function () {
                if ($(this).val() === '') {
                    $(this).prop('name', '');
                }
            });
        });
    }

    function LoadArticles() {
        // Show loader after a small delay
        var objDelay = setTimeout(function () {
            // Overlay
            $('div.load').css('opacity', '0.3');

            // Loader
            $('div.load').prepend('<div class=\'page-loader\'></div>');
        }, 400);

        // Set parameters
        var strFilterLoad = '';
        if (window.location.href.indexOf('?') <= -1) {
            strFilterLoad = '?filterload=1';
        } else {
            strFilterLoad = '&filterload=1';
        }

        // Load page
        $('div.load').load(window.location.href + strFilterLoad, function () {
            // Check if product overview is visible
            var blnInViewPort = ElementInViewport($('div.load'));

            if (blnInViewPort === false) {
                $('html,body').animate({scrollTop: $('div.load').offset().top - 100}, 'fast');
            }

            // Remove delay
            clearTimeout(objDelay);

            // Change overlay
            $('div.load').css('opacity', '1');

            if (intCategoryNo > 0) {
                // Filters aanpassen
                $.post(strAjaxPath + 'catalog-filters.php' + window.location.search, 'intCategoryNo= ' + intCategoryNo + '&strPathName=' + window.location.pathname + '&strProductsFull=' + $('input#strProductsFull').val(), function (objResponse) {
                    // Filters opnieuw inladen
                    $('div.filter-wrapper').html(objResponse);

                    // Initialize
                    InitPager();
                    InitSortorder();
                    InitFilters();
                    InitAddToCart();

                }, 'html');
            } else {
                // Initialize
                InitPager();
            }
        });
    }

    function ElementInViewport(objElement) {
        //special bonus for those using jQuery
        if (objElement instanceof jQuery) {
            objElement = objElement[0];
        }

        var top = objElement.offsetTop;
        var left = objElement.offsetLeft;
        var width = objElement.offsetWidth;
        var height = objElement.offsetHeight;
        while (objElement.offsetParent) {
            objElement = objElement.offsetParent;
            top += objElement.offsetTop;
            left += objElement.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }


    // Add to cart
    function InitAddToCart() {
        AddToCart($('form.form-add-to-cart button.btn-basket'), false, true);
    }

    window.InitAddToCart = InitAddToCart;
    window.ElementInViewport = ElementInViewport;
    window.LoadArticles = LoadArticles;
    window.InitSortorder = InitSortorder;
    window.InitFilters = InitFilters;
    window.InitPager = InitPager;
});
